<template>
  <basic-layout v-if="isMobile">
    <template #default>
      <div class="gaokao">
        <div class="gaokao-sider">
          <div class="gaokao-sider-info">
            <div class="module-title">个人中心</div>
            <p class="welcome">
              尊敬的用户，您好！ <br />欢迎使用"标准日本语"等系列图书配套资源!
            </p>
            <div class="nav-item">
              <router-link to="/gaokao/list">图书激活</router-link>
            </div>
            <div class="nav-item">
              <router-link to="/gaokao/search">账号查询</router-link>
            </div>
          </div>
          <div class="gaokao-sider-books">
            <div class="module-title">我的图书</div>
            <div
              class="sider-books"
              v-for="(series, index) in handleBookList"
              :key="index"
            >
              <template v-for="(book, bookInd) in series">
                <div
                  class="sider-books-item"
                  v-if="
                    book.book_id != 10005 &&
                    book.book_id != 10006 &&
                    book.book_id != 10009 &&
                    book.book_id != 10010 &&
                    book.book_id != 10011 &&
                    book.book_id != 10017 &&
                    book.book_id != 10018 &&
                    (book.series != 'br3dzs' || book.book_id == 10016)
                  "
                  :key="bookInd"
                  @click="clickBook(book)"
                >
                  <img :src="book.book_ico" alt="" />
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="gaokao-main">
          <router-view></router-view>
        </div>

        <active-book
          ref="ActiveBook"
          @submitPopupData="getBookList"
        ></active-book>
      </div>
    </template>
  </basic-layout>

  <study-layout v-else>
    <template #header>
      <div class="header-menu-item" @click="logOut">退出登录</div>
    </template>
    <template #default>
      <div class="gaokao">
        <div class="gaokao-sider">
          <div class="gaokao-sider-info">
            <div class="module-title">个人中心</div>
            <p class="welcome">
              尊敬的用户，您好！ <br />欢迎使用"标准日本语"等系列图书配套资源!
            </p>
            <div class="nav-item">
              <router-link to="/gaokao/list">图书激活</router-link>
            </div>
            <div class="nav-item">
              <router-link to="/gaokao/search">账号查询</router-link>
            </div>
          </div>
          <div class="gaokao-sider-books">
            <div class="module-title">我的图书</div>
            <div
              class="sider-books"
              v-for="(series, index) in handleBookList"
              :key="index"
            >
              <template v-for="(book, bookInd) in series">
                <div
                  class="sider-books-item"
                  v-if="
                    book.book_id != 10006 &&
                    book.book_id != 10009 &&
                    book.book_id != 10010 &&
                    book.book_id != 10011 &&
                    book.book_id != 10017 &&
                    book.book_id != 10018 &&
                    (book.series != 'br3dzs' || book.book_id == 10016)
                  "
                  :key="bookInd"
                  @click="clickBook(book)"
                >
                  <img :src="book.book_ico" alt="" />
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="gaokao-main">
          <router-view></router-view>
        </div>

        <active-book
          ref="ActiveBook"
          @submitPopupData="getBookList"
        ></active-book>
      </div>
    </template>
  </study-layout>
</template>

<script>
import ActiveBook from "./ActiveBook.vue";
import { BasicLayout, StudyLayout } from "@/components/Layouts/index";
import { check_browser } from "@/utils";

const userInfo = JSON.parse(localStorage.getItem("rypc_userInfo")) || {};
export default {
  components: { BasicLayout, StudyLayout, ActiveBook },
  data() {
    return {
      userInfo,
      handleBookList: [],
    };
  },
  computed: {
    bookList: (vm) => vm.$store.getters.bookList,
    curBook: (vm) => vm.$store.getters.curBook,
    // 检测是否为移动端
    isMobile() {
      return check_browser() !== "pc";
    },
  },
  watch: {
    bookList: {
      handler(newVL) {
        this.handleBookList = [
          newVL.gaokao,
          newVL.brdzslx,
          newVL.yiwu || [],
          newVL.br3dzs,
        ];
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.getBookList();
  },
  methods: {
    logOut() {
      this.$store.dispatch("logOut");
    },
    getBookList() {
      const params = {
        book_id: 0,
      };
      this.$store.dispatch("getActivateBookListAction", params).then(() => {});
    },
    clickBook(item) {
      // console.log("测试", item);
      if (
        item.is_rx_study_card != 0 ||
        ((item.activation_status == 2 || item.activation_status == 0) &&
          item.activation_code != "") ||
        item.is_study_card != 0
      ) {
        this.$store.dispatch("choiceCurBook", item).then(() => {});
        sessionStorage.setItem("rypc_book", JSON.stringify(item));
        this.$router.push({
          path: "/gaokao/courseware",
        });
      } else {
        this.$refs.ActiveBook.openModal({
          book_id: item.book_id,
          book_title: item.book_title,
          type: 1,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.gaokao {
  width: 1002px;
  margin: 0 auto;
  display: flex;
  padding-top: 20px;
  height: 620px;

  ::v-deep .module-title {
    padding-left: 14px;
    font-size: 14px;
    color: #000;
    font-weight: 700;
    position: relative;
    line-height: 18px;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 1px;
      width: 4px;
      height: 16px;
      background: #d8474c;
    }
  }

  .gaokao-sider {
    width: 212px;
    user-select: none;
    display: flex;
    flex-direction: column;

    &-info {
      background: white;
      border-radius: 2px;
      padding: 12px 15px;
      height: 180px;
      color: #000;
      box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.5);

      .welcome {
        font-size: 12px;
        line-height: 1.6em;
        padding-left: 14px;
        padding-bottom: 10px;
        margin-top: 8px;
      }

      .nav-item {
        font-size: 12px;
        color: #000;
        line-height: 1.6em;
        margin-top: 5px;
        border-bottom: 1px solid #ccc;
        padding: 0 4px;
        position: relative;

        & > a::after {
          content: ">>";
          position: absolute;
          font-family: Symbol;
          font-size: 10px;
          right: 4px;
          top: 0px;
        }
      }
    }

    &-books {
      background: white;
      border-radius: 2px;
      padding: 12px 15px;
      flex: 1;
      margin: 10px 0 0 0;
      box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.5);

      .sider-books {
        display: flex;
        flex-wrap: wrap;
        &-item {
          width: 50px;
          min-height: 70px;
          margin-right: 10px;
          margin-top: 10px;
          cursor: pointer;
          img {
            width: 50px;
            height: 70px;
            object-fit: fill;
          }
        }
      }
    }
  }

  .gaokao-main {
    flex: 1;
    margin-left: 10px;
  }
}

// PC端样式优化（确保阴影完整显示）
@media (min-width: 1025px) {
  .gaokao {
    .gaokao-sider {
      &-info {
        margin: 0 0 15px 0 !important;
        box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.4) !important;
      }

      &-books {
        margin: 15px 0 0 0 !important;
        box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.4) !important;
      }
    }

    .gaokao-main {
      margin-left: 15px !important;
      box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.4) !important;
    }
  }
}

// 移动端响应式样式
@media (max-width: 1024px) {
  .gaokao {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 15px !important;
    height: auto !important;
    min-height: calc(100vh - 200px) !important;
    flex-direction: column !important;

    ::v-deep .module-title {
      padding-left: 16px !important;
      font-size: 16px !important;
      color: #000 !important;
      font-weight: 700 !important;
      position: relative !important;
      line-height: 20px !important;
      margin-bottom: 15px !important;

      &::before {
        content: "" !important;
        position: absolute !important;
        left: 0 !important;
        top: 1px !important;
        width: 4px !important;
        height: 18px !important;
        background: #d8474c !important;
      }
    }

    .gaokao-sider {
      width: 100% !important;
      max-width: 100% !important;
      margin-bottom: 20px !important;

      &-info {
        height: auto !important;
        min-height: 150px !important;
        padding: 15px !important;

        .welcome {
          font-size: 14px !important;
          line-height: 1.8 !important;
          padding: 10px 14px !important;
        }

        .nav-item {
          font-size: 14px !important;
          padding: 8px 4px !important;
          margin-top: 8px !important;
        }
      }

      &-books {
        padding: 15px !important;
        margin-top: 15px !important;

        .sider-books {
          justify-content: center !important;

          &-item {
            width: 60px !important;
            height: 80px !important;
            margin: 8px !important;

            img {
              width: 60px !important;
              height: 80px !important;
            }
          }
        }
      }
    }

    .gaokao-main {
      margin-left: 0 !important;
      width: 100% !important;
      max-width: 100% !important;
    }
  }
}

// 平板端响应式样式
@media (max-width: 1042px) and (min-width: 1025px) {
  .gaokao {
    width: 90% !important;
    max-width: 1000px !important;
    margin: 0 auto !important;
    padding: 15px 0 !important;
  }
}

// 小屏幕设备优化
@media (max-width: 768px) {
  .gaokao {
    padding: 10px !important;

    ::v-deep .module-title {
      padding-left: 14px !important;
      font-size: 15px !important;
      line-height: 19px !important;
      margin-bottom: 12px !important;

      &::before {
        width: 4px !important;
        height: 17px !important;
      }
    }

    .gaokao-sider {
      &-info {
        padding: 12px !important;

        .welcome {
          font-size: 13px !important;
          padding: 8px 14px !important;
        }

        .nav-item {
          font-size: 13px !important;
          padding: 6px 4px !important;
        }
      }

      &-books {
        padding: 12px !important;

        .sider-books {
          &-item {
            width: 55px !important;
            height: 75px !important;
            margin: 6px !important;

            img {
              width: 55px !important;
              height: 75px !important;
            }
          }
        }
      }
    }
  }
}

// 超小屏幕设备优化
@media (max-width: 480px) {
  .gaokao {
    padding: 8px !important;

    ::v-deep .module-title {
      padding-left: 12px !important;
      font-size: 14px !important;
      line-height: 18px !important;
      margin-bottom: 10px !important;

      &::before {
        width: 3px !important;
        height: 16px !important;
      }
    }

    .gaokao-sider {
      &-info {
        padding: 10px !important;

        .welcome {
          font-size: 12px !important;
          padding: 6px 14px !important;
        }

        .nav-item {
          font-size: 12px !important;
          padding: 5px 4px !important;
        }
      }

      &-books {
        padding: 10px !important;

        .sider-books {
          &-item {
            width: 50px !important;
            height: 70px !important;
            margin: 5px !important;

            img {
              width: 50px !important;
              height: 70px !important;
            }
          }
        }
      }
    }
  }
}

// 确保在所有设备上都没有水平滚动
@media (max-width: 1200px) {
  .gaokao {
    .gaokao-sider,
    .gaokao-main {
    }
  }
}
</style>
